import { LoaderProvider, useLoading, BallTriangle } from "@agney/react-loading"
import React, { Component } from "react"
import { useTranslation } from "react-i18next"
import { commonConst } from "../data/commonConst"

function Loader() {
  const { t: commonLocalization } = useTranslation(["common"])
  const { containerProps, indicatorEl } = useLoading({
    loading: true,
  })
  return (
    <section {...containerProps}>
      {indicatorEl} {commonLocalization(commonConst.LOADING)} {indicatorEl}
    </section>
  )
}

export default Loader
